import React, { useState, useEffect, useMemo } from 'react';
import EditarCadastrarConta from './EditarCadastrar';
import { Container, InputGroup, Table } from 'rsuite';
import { useAuth } from '../../hooks/auth';
import { ContentHeader } from '../../components/ContentHeader';
import { debounce } from '../../components/funcoes';
import { MdAccountBalanceWallet } from "react-icons/md";
import PlusIcon from '@rsuite/icons/Plus';
import SearchIcon from '@rsuite/icons/Search';
import api from '../../services/api';

import '../style.css';
import { useCustomTheme } from '../../hooks/useCustomTheme';
import { CustomButton } from '../../components/CustomButton';
import { CustomInput } from '../../components/CustomInput';
import { CustomCell } from '../../components/CustomCell';
import { CustomHeaderCell } from '../../components/CustomHeaderCell';

const { Column } = Table;

export default function ContasTrasnferencia() {
  const { id_empresa } = useAuth();
  const [loading, setLoading] = useState(true);
  const [contas, setContas] = useState([]);
  const [conta, setConta] = useState(null);
  const [open, setOpen] = useState(false);
  const { theme } = useCustomTheme();

  const [busca, setBusca] = useState('');

  const contasMemo = useMemo(
    () =>
      busca.trim() === ''
        ? contas
        : contas.filter(({ Banco = '' }) =>
            Banco?.toLocaleLowerCase().includes(busca),
          ),
    [busca, contas],
  );

  const atualizar = async () => {
    await api
      .get(`conta/listarGestor/${id_empresa}`)
      .then((res) => {
        setContas(res.data);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const abrirDados = (conta) => {
    setConta(conta);
    setOpen(true);
  };

  const debounceSearch = debounce((valor = '') => {
    setBusca(valor.toLocaleLowerCase());
  }, 1000);

  const cadastrar = () => {
    setConta(null);
    setOpen(true);
  };

  useEffect(() => {
    atualizar();
  }, []);

  return (
    <Container
      style={{
        padding: '10px',
        height: 'calc(100vh - 60px)',
        backgroundColor: theme.colors.background,
      }}
    >
      <ContentHeader
        title="Contas Bancárias"
        subtitle="Gerencie as contas bancárias da sua empresa"
        icon={MdAccountBalanceWallet}
        secondComponent={
          <InputGroup inside style={{ width: '36vw', border: 'none' }}>
            <CustomInput onChange={debounceSearch} />
            <InputGroup.Addon>
              <SearchIcon color={theme.colors.textSecondary} />
            </InputGroup.Addon>
          </InputGroup>
        }
        thirdComponent={
          <CustomButton
            appearance="primary"
            onClick={() => {
              cadastrar();
            }}
          >
            <PlusIcon style={{ marginRight: 10 }} />
            Cadastrar Conta
          </CustomButton>
        }
      />
      <Table
        height={window.innerHeight - 60 - 90}
        autoHeight
        bordered={true}
        loading={loading}
        data={contasMemo}
        width={'100%'}
        style={{
          overflowY: 'auto',
          borderColor: theme.colors.backgroundSecondary,
          backgroundColor: theme.colors.backgroundSecondary,
          color: theme.colors.textSecondary,
        }}
        locale={{
          emptyMessage: 'Nenhuma conta bancária encontrada',
          loading: 'Carregando...',
        }}
      >
        <Column
          style={{
            background: theme.colors.backgroundSecondary,
            color: theme.colors.textSecondary,
          }}
          align="center"
          fixed
        >
          <CustomHeaderCell>Id</CustomHeaderCell>
          <CustomCell dataKey="Id" />
        </Column>

        <Column
          style={{
            background: theme.colors.backgroundSecondary,
            color: theme.colors.textSecondary,
          }}
          flexGrow={1}
        >
          <CustomHeaderCell>Banco</CustomHeaderCell>
          <CustomCell dataKey="Banco" />
        </Column>

        <Column
          style={{
            background: theme.colors.backgroundSecondary,
            color: theme.colors.textSecondary,
          }}
          flexGrow={1}
        >
          <CustomHeaderCell>Agencia</CustomHeaderCell>
          <CustomCell>
            {(rowData) => (
              <text>
                {Boolean(parseInt(rowData.UsaPix)) ? 'PIX' : rowData.Agencia}
              </text>
            )}
          </CustomCell>
        </Column>

        <Column
          style={{
            background: theme.colors.backgroundSecondary,
            color: theme.colors.textSecondary,
          }}
          flexGrow={1}
        >
          <CustomHeaderCell>Conta</CustomHeaderCell>
          <CustomCell>
            {(rowData) => (
              <text>
                {Boolean(parseInt(rowData.UsaPix))
                  ? rowData.Pix
                  : rowData.Conta}
              </text>
            )}
          </CustomCell>
        </Column>

        <Column
          style={{
            background: theme.colors.backgroundSecondary,
            color: theme.colors.textSecondary,
          }}
          width={100}
          fixed="right"
        >
          <CustomHeaderCell>Ativo</CustomHeaderCell>
          <CustomCell dataKey="Fim">
            {(rowData) => (
              <span style={{ padding: 0 }}>
                <CustomButton
                  appearance={rowData.Ativo ? 'ghost' : 'primary'}
                  style={{
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '0 10px',
                  }}
                >
                  {rowData.Ativo ? 'Sim' : 'Não'}
                </CustomButton>
              </span>
            )}
          </CustomCell>
        </Column>

        <Column
          style={{
            background: theme.colors.backgroundSecondary,
            color: theme.colors.textSecondary,
          }}
          width={100}
          fixed="right"
        >
          <CustomHeaderCell>Opções</CustomHeaderCell>
          <CustomCell>
            {(rowData) => (
              <>
                <span>
                  <CustomButton
                    onClick={() => {
                      abrirDados(rowData);
                    }}
                    color={theme.colors.warning}
                    appearance="ghost"
                    size="xs"
                  >
                    Editar
                  </CustomButton>
                </span>
              </>
            )}
          </CustomCell>
        </Column>
      </Table>
      {open && (
        <EditarCadastrarConta
          modal={open}
          close={() => setOpen(false)}
          objConta={conta}
          contas={contas}
          setContas={setContas}
          IdEmpresa={id_empresa}
        />
      )}
    </Container>
  );
}
